import { http } from "./http";

function cleanParams(params = {}) {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    out[key] = value;
  });
  return out;
}

export const ActivityLogsService = {
  async list(params = {}) {
    return http("/api/admin/logs", {
      method: "GET",
      params: cleanParams(params),
    });
  },

  async summary(params = {}) {
    return http("/api/admin/logs/summary", {
      method: "GET",
      params: cleanParams(params),
    });
  },

  async getById(id) {
    return http(`/api/admin/logs/${id}`, {
      method: "GET",
    });
  },

  async deleteById(id) {
    return http(`/api/admin/logs/${id}`, {
      method: "DELETE",
    });
  },

  async deleteAll(params = {}) {
    return http("/api/admin/logs", {
      method: "DELETE",
      params: cleanParams(params),
    });
  },
};

export default ActivityLogsService;